import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosApi } from "../../helpers/AxiosApi";
import { toast } from "react-toastify";
import initialStates from "./state";

export const getDashboardData = createAsyncThunk(
  "getDashboardData",
  async ({ year }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`dashboard?year=${year}`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboardData",
  initialState: initialStates,
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.getDashboardDataStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getDashboardData.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});

const { reducer } = dashboardSlice;
export default reducer;
